import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.POST

export default class OspreyOffersShareToAffiliations extends BaseAction {
    constructor(dataKey) {
        const id = '70e4d14a-28c5-4ca8-96f9-abfae4758d8a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToAffiliations(params) {
        const { offerId, affiliationIdList } = params

        this.path = `/${resource}/${offerId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-affiliations-share.js